// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusOutlinedSvg from "@fishx/icons-svg/es/asn/MinusOutlined";
import FishxIcon from '../components/FishxIcon';

var MinusOutlined = function MinusOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusOutlinedSvg
  }));
};

MinusOutlined.displayName = 'MinusOutlined';
export default React.forwardRef(MinusOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MinusOutlined.js
// module id = 3137
// module chunks = 0